import IconLibrary from '../../../../src/components/IconLibrary';
import React from 'react';
export default {
  IconLibrary,
  React
};